import React, { useEffect, useRef, useState } from "react";
import Logo from "../../assets/imgs/inyc_static.png";
import { useUser } from "../../context/UserContext/UserProvider";
import { useData } from "../../context/DataContext/DataProvider";
import Loader from "../icons/Loader";

const UILoader = ({ style }) => {
  const { isLoading } = useUser();
  const [appLoading, setAppLoading] = useState();
  const { userLocationLoading } = useData();
  const loaded = useRef(false);

  useEffect(() => {
    if (loaded.current) return;
    setAppLoading(true);
  
    const runCheck = () => {
      console.log("checking", isLoading, userLocationLoading);
      if (!isLoading && !userLocationLoading) {
        setAppLoading(false);
        loaded.current = true;
        clearTimeout(maxTimeout);
      } else {
        timer = setTimeout(runCheck, 1000);
      }
    };
  
    let timer = setTimeout(runCheck, 1000);
    let maxTimeout = setTimeout(() => {
      setAppLoading(false);
      loaded.current = true;
      clearTimeout(timer);
    }, 8000);
  
    return () => {
      clearTimeout(timer);
      clearTimeout(maxTimeout);
    };
  }, [isLoading, userLocationLoading]);

  return (
    <div
      style={{
        width: "100vw",
        height: "calc(100vh - var(--inyc-bottom-space))",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 20000,
        background: "var(--inyc-loader-background)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        transition: "0.3s",
        alignItems: "center",
        opacity: appLoading === undefined ? 1 : appLoading ? 1 : 0,
        pointerEvents: appLoading === undefined ? 'all' : appLoading ? "all" : "none",
      }}
    >
      <img
        src={Logo}
        alt="logo"
        className="invert-[var(--inyc-invert-black)]"
        style={{
          width: "45%",
          maxWidth: "350px",
          objectFit: "contain",
          objectPosition: "center",
        }}
      />
      <Loader />
    </div>
  );
};

export default UILoader;
